import COUNTRIES from './countries.json';

export default class Country {
  static get = get;
  static getAll = getAll();
  constructor(name) {
    if (!name) {
      this.countries = COUNTRIES;
      return;
    }
    const data = find(name);
    if (data) {
      Object.assign(this, data);
      return this;
    }
    console.log(`Country ${name} was not found`);
  }
}

function find(name) {
  return COUNTRIES.find((country) => {
    return [country.alpha2Code, country.alpha3Code, country.name].includes(
      name
    );
  });
}

function get(name) {
  let isCode = name && name === name.toUpperCase();
  let countries = [];
  if (name) {
    countries = COUNTRIES.slice().filter((data) => {
      let match = isCode
        ? data.alpha2Code === name || data.alpha3Code === name
        : data.name.match(new RegExp(name, 'i'));
      if (match) {
        data.sortIndex = isCode ? 0 : match.index;
        return true;
      }
      return false;
    });
    countries = isCode
      ? countries
      : countries.sort((a, b) => a.sortIndex - b.sortIndex);
  } else {
    countries = getAll();
  }
  if (Array.isArray(countries)) {
    return countries;
  }
  return countries;
}

function getAll() {
  return COUNTRIES;
}

export function getFlag(name) {
  return new Country(name).flag;
}

export function getCurrency(name) {
  return new Country(name).currency;
}

export function getCountry(name) {
  return new Country(name);
}

export function getCountries() {
  return COUNTRIES;
}
